<template>
  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-hidden="true">
					&times;
				</button>
				<h4 class="modal-title" id="myModalLabel">
					{{productContent.content.title}}
				</h4>
			</div>
			<div class="modal-body modalScrollable">
               <div v-html="productContent.content.describe"></div>
                <div class="row">
                    <div v-for="pimg in productContent.content.images" :key="pimg" class="col-md-6" >
                        <div class="image-wraper">
                            <img class="img-responsive" :src="pimg" alt="">
                        </div>
                    </div>
                    
                </div>

                <div v-html="productContent.content.technology"></div>
			</div>
			
		</div>
	</div>
  </div>
</template>


<script>
export default {
  name: 'productModal',
  props:['productContent'],
   
}
</script>

<style scoped>
.col-md-6{
    margin: 10px 0;
}


</style>


// WEBPACK FOOTER //
// src/components/productModal.vue